import { Drawer, Grid2, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { FileTypeEnum } from "../../_common/enum";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../_services/fileUpload.service";


export const DocumentManageDrawer = (params: { fileTypeId: string, isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const resetData = () => ({
        file: null
    });

    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [upload, setUpload] = useState<{ file: any | null }>(resetData());

    const ALLOWED_FILE_EXTENSIONS = [
        ".bmp", ".jpeg", ".jpg", ".png", ".gif",
        ".pdf", ".txt", ".docx", ".xlsx",
        ".msg", ".eml", ".zip",
    ];

    const FILE_UPLOAD_ACCEPT = ALLOWED_FILE_EXTENSIONS.join(",");

    const isAllowedFile = (file: File): boolean => {
        const extension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
        return ALLOWED_FILE_EXTENSIONS.includes(extension);
    };
    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function onUploadChange(event: any) {

        setUpload((prev: any) => {
            const _upload = prev
            _upload.file = event.target.files[0];
            return _upload
        })

    }

    function submit(e: any) {
        if (!upload.file) return;
        e.preventDefault();
        setIsSaving(true);
        if (!isAllowedFile(upload.file)) {
            // Replace with your existing toast or notification.
            alert("Unsupported file type. Allowed types: " + FILE_UPLOAD_ACCEPT);
            return;
        }

        const formData = new FormData();
        formData.append("file", upload.file);
        formData.append("fileTypeId", params.fileTypeId);
        return fileUploadService
            .uploadFile(formData)
            .then(
                () => {
                    toastr.success("File Upload was successful.");
                    params.onSave();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }


    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Upload File"} onClose={params.onClose} />

            <ValidatorForm onSubmit={submit} noValidate>
                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            label="File to Upload"
                            type="file"
                            id="file"
                            required
                            fullWidth
                            onChange={onUploadChange}
                            inputProps={{
                                accept: FILE_UPLOAD_ACCEPT
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            saving={saving}
                            icon="save"
                            type="submit"
                        >
                            Save
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>
        </Drawer>
    )
}